import { createBaseApi } from '@delmonicos/shared-sdk/libs/emsp/src/clients/redux/back-office/base.api';
import { baseQueryBuilder } from '@service/base-query.builder';

export const baseApi = createBaseApi(baseQueryBuilder());
